import { jwtDecode } from 'jwt-decode'
import { IToken } from 'models/interfaces'
import { getLocalStorageToken } from 'store/localStorage'

/** graphql-api's PrivilegeLevel.Admin — what /admin's queries need. */
export const ADMIN_PRIVILEGE_LEVEL = 3

/** graphql-api's PrivilegeLevel.SuperAdmin — Flexime staff. */
export const SUPER_ADMIN_PRIVILEGE_LEVEL = 4

/**
 * The signed-in user's privilege level, from the JWT (as the sidebar reads it). For showing or hiding
 * controls only — graphql-api enforces the level on every mutation itself.
 */
export function getPrivilegeLevel(): number {
  try {
    return jwtDecode<IToken>(getLocalStorageToken())?.user?.privilegeLevel ?? 1
  } catch {
    return 1
  }
}

/** The signed-in user's id, from the JWT; null when there is no readable token. */
export function getSignedInUserId(): number | null {
  try {
    return jwtDecode<IToken>(getLocalStorageToken())?.user?.id ?? null
  } catch {
    return null
  }
}
